const state = {
  checkHeader: 1
}
const mutations = {
  storageHeader: (state, msg) => {
    state.checkHeader = msg.checkHeader
  }
}
const actions = {
  actionHeader({ commit }, info) {
    commit('storageHeader', info)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
